import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// RecipeCatalog entry point - Mounts RecipeCatalog component to WordPress
import React from 'react';
import ReactDOM from 'react-dom/client';
import '../styles/globals.css';
// Import RecipeCatalog component
import { RecipeCatalog } from '@/pages/RecipeCatalog';
import { Toaster } from '@/components/ui/sonner';
// Debug: Log when entry file loads
console.log('[RecipeCatalog] Entry file loaded');
// Mount function
function mountRecipeCatalog() {
    var _a, _b;
    const mountPoint = document.getElementById('recipe-catalog-root');
    if (!mountPoint) {
        console.warn('[React] RecipeCatalog mount point not found');
        return;
    }
    // Get WordPress data
    const wpData = window.wpData || {};
    // Quiz click handler
    const handleQuizClick = () => {
        window.location.href = '/glossary-quiz';
    };
    // Navigation handler for WordPress
    const handleNavigate = (page, recipeSlug) => {
        // Handle recipe-detail navigation with slug
        if (page === 'recipe-detail' && recipeSlug) {
            window.location.href = `/recipes/${recipeSlug}/`;
            return;
        }
        const pageMap = {
            home: '/',
            catalog: '/categories',
            'design-system': '/design-system',
            login: '/login',
            menu: '/menu',
            'recipe-box': '/recipe-box',
            recipes: '/recipes',
            profile: '/profile',
            'shopping-list': '/shopping-list',
        };
        // For catalog, try multiple slugs in order of preference
        if (page === 'catalog') {
            const catalogSlugs = ['/catalog', '/categories', '/generic-catalog'];
            // Try the first slug (WordPress will handle 404 if it doesn't exist)
            window.location.href = catalogSlugs[0];
            return;
        }
        const url = pageMap[page] || '/';
        window.location.href = url;
    };
    // Create root and render
    const root = ReactDOM.createRoot(mountPoint);
    root.render(_jsxs(React.StrictMode, { children: [_jsx(RecipeCatalog, { onNavigate: handleNavigate, menuItems: ((_a = wpData.menus) === null || _a === void 0 ? void 0 : _a.primary) || [], footerMenuItems: ((_b = wpData.menus) === null || _b === void 0 ? void 0 : _b.footer) || [], siteName: wpData.siteName, onQuizClick: handleQuizClick }), _jsx(Toaster, {})] }));
}
// Auto-mount when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountRecipeCatalog);
}
else {
    mountRecipeCatalog();
}
// Export for manual mounting if needed
export { mountRecipeCatalog };
